import { AnyAaaaRecord } from 'dns';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { log } from 'console';

interface RequestObject {
  id: {
    act_id: number;
    jwt: {
      uid: string;
    };
  };
  operation: string;
  app_cd?: string;
  from?: {
    schema: string;
    table: string;
  };
  where?: {
    [key: string]: any;
  };
  limit?: number;
  offset?: number;
  order?: string[];
  group?: string[];
  having?: {
    [key: string]: any;
  };
  include?: any;
}

@Injectable({
  providedIn: 'root'
})
export class MainService {
  erpUser: any
  le_id: any
  act_id: any
  dependent_on: string;

  constructor(private http: HttpClient) {
    console.log('environment-constructor')
    // if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
    //   let erpUserString = sessionStorage.getItem('erpUser');
    //   this.erpUser = erpUserString && JSON.parse(erpUserString);
    //   this.le_id = this.erpUser.le_id;
    //   this.act_id = this.erpUser.b_acct_id
    //   console.log(this.erpUser)
    // }
    this.setUserAccount()
  }
  apiHost: any
  apiPort: any
  baseUrl: any
  async setUserAccount() {
    if (this.le_id == undefined && this.le_id == undefined) {
      if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
        let erpUserString = sessionStorage.getItem('erpUser');
        this.erpUser = erpUserString && JSON.parse(erpUserString);
        this.le_id = this.erpUser.le_id;
        this.act_id = this.erpUser.b_acct_id
        console.log(this.erpUser)
      }

    }
  }

  async getAllEnvConfig(object: any) {
    this.apiHost = object.apiHostDd || "http://localhost";
    this.apiPort = object.apiPortDd || 3000;



    this.baseUrl = this.apiHost + ':' + this.apiPort + '/dd';
    console.log('ddAPI @ ' + this.baseUrl + ' is being used.');
  }



  formatTime(timestamp: string) {
    const currentTime = new Date();
    const targetTime = new Date(timestamp);

    const timeDifference = Math.abs(currentTime.getTime() - targetTime.getTime());
    const minutes = Math.floor(timeDifference / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return days === 1 ? "1 day ago" : days + " days ago";
    } else if (hours > 0) {
      return hours === 1 ? "1 hour ago" : hours + " hours ago";
    } else if (minutes > 0) {
      return minutes === 1 ? "1 min ago" : minutes + " min ago";
    } else {
      return "just now";
      
    }
  }
  generateStringField(field) {
    const schema = {
      type: ['string', 'null'],
      title: field.di_bus_nm || '',
      // Add other properties specific to string type
    };

    // Add minLength and maxLength if provided in the field object
    if (field.datatype.hasOwnProperty('minLength')) {
      schema['minLength'] = field.datatype.minLength;
    }

    if (field.datatype.hasOwnProperty('maxLength')) {
      schema['maxLength'] = field.datatype.maxLength;
    }
    if (field.cl && field?.iscl) {
      schema['enum'] = field.cl.map(item => item['cl_cd']);
    }
    // if (field.hasOwnProperty('default')) {
    //   schema['default'] = field.default?.const;
    // }
    const required = field.nullable ? false : true;
    return { schema, required };
  }


  generateDateTimeField(field: any) {
    const schema = {
      type: ['string', 'null'],
      format: 'date-time',
      title: field.di_bus_nm || '',
      // Add other properties specific to datetime type
    };

    if (field.cl && field?.iscl) {
      schema['enum'] = field.cl.map(item => item['cl_cd']);
    }
    // if (field.hasOwnProperty('default')) {
    //   schema['default'] = field.default?.const;
    // }

    const required = field.nullable ? false : true;
    return { schema, required };
  }

  generateJsonField1(field: any) {
    const schema = {
      type: 'string',
      title: field.di_bus_nm || '',
      // Add other properties specific to json type
    };

    if (field.cl && field?.iscl) {
      schema['enum'] = field.cl.map(item => item['cl_cd']);
    }

    const required = field.nullable ? false : true;
    return { schema, required };
  }
  observer: any
  dependentTerm: any
  async generateJsonField(field: any) {
    //   console.log(field)
    let schema = {}
    if (field?.datatype?.dt_tcd_json?.dependent_on) {
      this.dependent_on = field?.datatype?.dt_tcd_json?.dependent_on;
      this.dependentTerm = field?.di_tech_nm
      schema = {
        type: 'object',
        // title: field.di_bus_nm || '',
        properties: {}

      };

      // if (field.cl && Array.isArray(field.cl.av_init)) {
      //   schema['enum'] = field.cl.av_init.map(item => item[0]);
      // }




    }
    else {
      //  console.log(field,'field')
      schema = await this.getSchema(field?.datatype)
      // console.log(schema)
    }
    this.notTitleArr = []
    await this.addTitlesToSchema(schema);
    console.log(this.notTitleArr, 'notTitleArr')
    const required = field.nullable ? false : true;
    return { schema, required };
  }

  generateDateField(field: any) {
    const schema = {
      type: ['string', 'null'],
      format: 'date',
      title: field.di_bus_nm || '',

    };

    if (field.cl && field?.iscl) {
      schema['enum'] = field.cl.map(item => item['cl_cd']);
    }
    // if (field.hasOwnProperty('default')) {
    //   schema['default'] = field.default?.const;
    // }

    const required = field.nullable ? false : true;
    return { schema, required };
  }

  generateIntegerField(field: any) {
    const schema = {
      type: 'integer',
      title: field.di_bus_nm || '',

    };

    if (field.cl && field?.iscl) {
      schema['enum'] = field.cl.map(item => item['cl_cd']);
    }
    // if (field.hasOwnProperty('default')) {
    //   schema['default'] = field.default?.const;
    // }

    const required = field.nullable ? false : true;
    return { schema, required };
  }

  generateDecimalField(field: any) {
    const schema = {
      type: 'number',
      title: field.di_bus_nm || '',

    };

    if (field.cl && field?.iscl) {
      schema['enum'] = field.cl.map(item => item['cl_cd']);
    }
    // if (field.hasOwnProperty('default')) {
    //   schema['default'] = field.default?.const;
    // }

    const required = field.nullable ? false : true;
    return { schema, required };
  }

  async generateFieldSchema(field) {
    console.log(field)
    this.dependent_on = null;
    switch ((field.type).toLowerCase()) {
      case 'string':
        return this.generateStringField(field);
      case 'datetime':
        return this.generateDateTimeField(field);
      case 'json':
        return this.generateJsonField(field);
      case 'date':
        return this.generateDateField(field);
      case 'integer':
        return this.generateIntegerField(field);
      case 'decimal':
        return this.generateDecimalField(field);
      default:
        return this.generateStringField(field);
    }
  }

  async getSchemaByType(json, type) {
    return json?.dt_tcd_json?.schema[type]
  }
  async getSchema(json) {
    return json?.dt_tcd_json?.schema
  }
  notTitleArr = []
  async addTitlesToSchema(schema: any): Promise<void> {
    if (schema && typeof schema === 'object') {

      if (schema.properties) {
        await Promise.all(Object.entries(schema.properties).map(async ([key, property]) => {

          if (property && (property['type'] === 'object' || (property['type'] === 'array' && property['items']) || (property['oneOf'] && property['oneOf'].length > 0))) {
            await this.addTitlesToSchema(property);
          }

          if (property) {
            let req_obj: any = new Object();
            req_obj['act_id'] = this.act_id;
            req_obj['di_tech_nm'] = key;
            req_obj['di_tcd'] = 'TR';
            req_obj['pf_path'] = 'dd';
            req_obj['pf_name'] = 'di';
            req_obj['app_cd'] = 'DD';

            let resp: any = await this.getBusinessName(req_obj);

            if (resp['error'] === false && resp['data'].length > 0) {
              property['title'] = resp['data'][0]['di_bus_nm'];
            } else {
              property['title'] = key;
              if (!this.notTitleArr.includes(key)) {
                this.notTitleArr.push(key);
              }
              //  this.notTitleArr.push(key);
            }
          }
        }));
      }


      if (schema.oneOf && schema.oneOf.length > 0) {
        await Promise.all(schema.oneOf.map(async (option: any) => {
          console.log(option)
          if (!option.title) {
            option.title = schema.$id || 'Untitled Option';
          }

          if (option && option.properties) {
            await this.addTitlesToSchema(option);
          }
        }));
      }


      if (schema.type === 'array' && schema.items && schema.items.type === 'object') {
        await this.addTitlesToSchema(schema.items);
      }


    }
  }
  async generateJSONSchema(fields) {
    // this.rrvconfig = config;
    const properties = {};
    const requiredFields = [];

    // Generate properties and collect required fields
    await Promise.all(fields.map(async (field) => {
      let retobj = await this.generateFieldSchema(field);
      console.log(retobj, 'RETOBJ')
      properties[field.di_tech_nm] = retobj['schema'];
      if (retobj['required']) {
        requiredFields.push(field.di_tech_nm);
      }
      console.log(requiredFields)
    }));


    const schema = {
      type: 'object',
      properties,
    };


    if (requiredFields.length > 0) {
      schema['required'] = requiredFields;
    }

    return schema;
  }




  async generateJSONSchema1(fields) {
    const properties = {};

    fields.forEach(async field => {
      properties[field.di_tech_nm] = await this.generateFieldSchema(field);
    });

    return {
      type: 'object',
      properties,
    };
  }
  async getListData(req_obj: any): Promise<any> {
    console.log('hiiapi1');
    await this.setUserAccount()

    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "find",
      "app_cd": req_obj['app_cd']
    }

    if (req_obj.hasOwnProperty('filter') && req_obj.filter !== null && req_obj.filter !== undefined) {
      requestObj['where'] = req_obj.filter;
    }
    if (req_obj.hasOwnProperty('limit') && req_obj.limit !== null && req_obj.limit !== undefined) {
      requestObj['limit'] = req_obj.limit;
    }

    if (req_obj.hasOwnProperty('offset') && req_obj.offset !== null && req_obj.offset !== undefined) {
      requestObj.offset = req_obj.offset;
    }
    if (req_obj.hasOwnProperty('order') && req_obj.order !== null && req_obj.order !== undefined) {
      requestObj.order = req_obj.order;
    }
    console.log(requestObj, 'requestObj')
    console.log(this.baseUrl)

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });

  }
  async getdtls(req_obj: any) {
    await this.setUserAccount()
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "operation": "find",
      "app_cd": "DD",

      "where": {
        "and": [
          { "di_tech_nm": { "=": [req_obj['di_tech_nm']] } },
          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      },
      "include": {
        "all": true
      }
    }
    //  console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        //console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async getBusinessName(req_obj: any): Promise<any> {
    await this.setUserAccount()
    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": 'dd',
        "table": 'di'
      },

      "operation": "find",
      "app_cd": 'DD',

      "select": [
        "di_id", "di_bus_nm", ["di_tcd_json.data_type.dt_tcd", "datatype"]
      ],
      "where": {
        "and": [
          { "di_tech_nm": { "=": req_obj['di_tech_nm'] } },
          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      }
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        // console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async getMultipleBusinessName(req_obj: any) {
    await this.setUserAccount()
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "operation": "find",
      "app_cd": "DD",
      "select": ["di_id", "di_tech_nm", "di_bus_nm",
        ["di_tcd_json.data_type.dt_tcd", "type"],
        ["di_tcd_json.data_type", "datatype"],
        ["di_tcd_json.nullable", "nullable"],
        ["di_tcd_json.default", "default"],
        ["di_tcd_json.cl_type", "iscl"]



      ],
      "where": {
        "and": [
          { "di_tech_nm": { "in": [req_obj['di_tech_nm']] } },
          { "di_tcd": { "=": req_obj['di_tcd'] } }

        ]
      },
      "include": {
        "all": true
      }
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async addData(req_obj: any): Promise<any> {
    await this.setUserAccount()

    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "into": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "insert",
      "app_cd": req_obj['app_cd'],
      columns: req_obj['columns'],
      values: req_obj['values']


    }
    console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async updateData(req_obj: any): Promise<any> {
    await this.setUserAccount()

    let requestObj: any = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "into": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },

      "operation": "update",
      "app_cd": req_obj['app_cd'],
      set: req_obj['set'],
      where: req_obj['where']


    }
    console.log(requestObj);

    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async PrimaryKey(req_obj: any) {
    await this.setUserAccount()
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": "dd",
        "table": "di"
      },
      "operation": "find",
      "app_cd": req_obj['app_cd'],
      "select": [
        ["di_tcd_json.primary_key.pk_keys", "PK"]
      ],
      "where": {
        "and": [
          { "di_tech_nm": { "=": req_obj['pf_name'] } },
          { "di_tcd": { "=": 'PF' } }

        ]
      }
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }
  async deleteData(req_obj: any) {
    await this.setUserAccount()
    let requestObj = {
      "id": {
        "act_id": this.act_id,
        "jwt": { "uid": this.le_id }
      },

      "from": {
        "schema": req_obj['pf_path'],
        "table": req_obj['pf_name']
      },
      "operation": "destroy",
      "app_cd": req_obj['app_cd'],

      "where": req_obj['where']
    }
    return this.http.post<any>(this.baseUrl, requestObj).toPromise()
      .then(response => {
        console.log(response);
        return response;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        throw error;
      });
  }

}
